"use client";

import { BuilderContent, isEditing } from "@builder.io/sdk-react";
import Script from "next/script";
import { Analytics } from "@/components/Analytics";
import { getNavatticCampaignId, hasNavattic } from "@/helpers/navattic";
import { Navattic } from "../Navattic";

export default function ConditionalScripts({
  content,
  isItProDayPage,
}: {
  content: BuilderContent;
  isItProDayPage: boolean;
}) {
  if (isEditing()) {
    return null;
  }

  return (
    <>
      {!content.data?.excludeCookieBannerScript && (
        <Script
          src="https://cookie-cdn.cookiepro.com/scripttemplates/otSDKStub.js"
          data-document-language
          data-dLayer-name="dataLayerOneTrust"
          type="text/javascript"
          data-domain-script={
            isItProDayPage
              ? (process.env.NEXT_PUBLIC_COOKIES_KEY_IT_PRO_DAY as string)
              : (process.env.NEXT_PUBLIC_COOKIES_KEY as string)
          }
          strategy="lazyOnload"
        />
      )}
      {hasNavattic(content.data?.blocks ?? []) && (
        <Navattic
          campaignId={getNavatticCampaignId(content.data?.blocks ?? [])}
        />
      )}
      {!content.data?.excludeAnalyticsScript && (
        <Analytics
          src={
            isItProDayPage
              ? (process.env
                  .NEXT_PUBLIC_ANALYTICS_LIB_REFERENCE_IT_PRO_DAY as string)
              : (process.env.NEXT_PUBLIC_ANALYTICS_LIB_REFERENCE as string)
          }
        />
      )}
    </>
  );
}
